module.exports = __webpack_public_path__ + "static/img/videoCover2.63ced604.png";